import SelectWeex from "../elements/SelectWeex";
import AddCourse from "../addCourse/AddCourse";
import Component from "../components/Component";
import KeyMapping from "./KeyMapping";
import deleteIcon from "../../img/delete.png"
import "./weekPlaner.css"
import {Modal} from "../Modal.tsx";
import React from "react";

export function isInPast(startOfWeek, index){
    let targetDate = new Date(startOfWeek);
    targetDate.setDate(startOfWeek.getDate() + index + 1);
    return targetDate < new Date();
}

function isToday(startOfWeek, index){
    let targetDate = new Date(startOfWeek);
    targetDate.setDate(startOfWeek.getDate() + index);
    return targetDate.toDateString() === new Date().toDateString();
}

export default function PlanerView({
                                       setSelectedCourseType,
                                       handleMouseMove,
                                       addModal,
                                       setHoveredDay,
                                       handleClick,
                                       getLeft,
                                       getWidth,
                                       setDraggedItem,
                                       setHoverItemHeight,
                                       handleDragEnd,
                                       setResizeItem,
                                       handleResize,
                                       hoveredDay,
                                       calcPxToTime,
                                       hoverItemHeight,
                                       getTop,
                                       addCoursePos,
                                       setAddModal,
                                       addToWeek,
                                       editValues,
                                       resizeItem,
                                       hoveredLeft,
                                       hoverTop,
                                       hoveredWidth,
                                       selectedCourseType,
                                       lineHeight,
                                       setEditValues,
                                       week,
                                       stylesPlanerView,
                                       startToInt,
                                       checkbox,
                                       onCheckbox,
                                       isSchedulePlaner = true,
                                       startOfWeek,
                                       courseTypes,
                                       locations,
                                       coaches,
                                       getWidthOfDay,
                                       weekdays,
                                       tags,
                                       setTags,
                                       preview,
                                       onDelete,
                                       deleteModal,
                                       onImport
                                   }){
    const previewHeight = 160
    const previewStyle = preview? {height: previewHeight}: {}
    function renderItemContent(item, key){
        if(isSchedulePlaner){
          return <div className={"item-content"}>
            <h3 style={{margin: "5px 0 5px 0"}}>{item.type}</h3>
            {item.startTime + " - " + item.endTime}
          </div>;
        }
        else{
            return <div className={"item-content"}>
                <h3 style={{margin: "5px 0 5px 0"}}>{item.name}</h3>
                {item.description.replace("<br/>", "\n").split("\n").map((e, i) =>
                    <div key={"lineText_" + i + "_" + key}>{e}</div>)
                }
            </div>;
        }
    }

    function renderItems(index){
        return <>
            {week[index].map((item, i) =>
                <div style={{
                    ...stylesPlanerView.item,
                    left: getLeft(index) + item.parId * getWidth(index, item) + 'px',
                    top: (startToInt(item.startTime) + 1) * (preview? previewHeight/25: lineHeight) + 'px',
                    height: !preview ? item.height + "px": 10,
                    width: getWidth(index, item).toString().endsWith("%") ? getWidth(index, item) : getWidth(index, item) + "px",
                    background: isSchedulePlaner ? (item.status === "canceled" ? "gray" :courseTypes?.find(e => e.short === item.type)?.color) : undefined,
                    overflowY: "scroll"
                }}
                     key={"item_" + index + "_" + i}
                     id={"item_" + index + "_" + i}
                    //todo just set item and align difference between begin-end and time-duration better, either or:
                     onClick={item.fixed ?
                         (e) => e.preventDefault() :
                         () => setEditValues({
                             ...item,
                             index: i
                         })}
                     draggable={resizeItem || item.fixed ? "false" : "true"}
                     onDragStart={() => {
                         setDraggedItem({hoveredDay, i, type: item.type});
                         setHoverItemHeight(item.height);
                     }}
                     onDrag={handleMouseMove}
                     onDragEnd={handleDragEnd}
                className={"calender-item" + (item.fixed ? "":" calender-item-fixed")}>
                    {!preview && renderItemContent(item, "item_" + index + "_" + i)}
                    {isSchedulePlaner && !preview && <div style={stylesPlanerView.resize}
                                              draggable
                                              onDragStart={() => setResizeItem({hoveredDay, i})}
                                              onDrag={handleResize}
                                              onDragEnd={() => {
                                                  setResizeItem(null);
                                                  setDraggedItem(null);
                                              }}
                    >
                        =
                    </div>}
                    {!preview && !item.fixed && <img
                        alt={"delete"}
                        className={"icon"}
                        style={stylesPlanerView.delete}
                        src={deleteIcon}
                        onClick={(e)=>onDelete(e, index, i, item)}
                    />}
                </div>
            )}
        </>;
    }

    return (<div style={stylesPlanerView.container}>
      {setSelectedCourseType && !preview && <div style={{position: "relative"}}>
        <SelectWeex
          isSearchable={false}
          options={courseTypes ?? []}
          value={selectedCourseType}
          onChange={(e) => setSelectedCourseType(e)}
          placeholder={"Kurs wählen"}
          style={stylesPlanerView.selector}
        />
        {onImport&&
          <button className={"secondarybutton"} style={stylesPlanerView.importer} onClick={onImport}>import von
            Crossfit.com
          </button>}
      </div>}
      {onCheckbox && !preview && <label>
        <input
          type="checkbox"
                checked={checkbox}
                onChange={onCheckbox}
            />
            Serie bearbeiten
        </label>}
        <div style={{...stylesPlanerView.innerContainer, ...previewStyle}}
             onMouseMove={handleMouseMove}
             id={"DnDArea"}
             onMouseLeave={() => addModal < 0 && setHoveredDay(-1)}
             onClick={handleClick}
        >
            <KeyMapping setAddModal={setAddModal}/>
            {!preview && <div style={stylesPlanerView.timesContainer}>
                {Array.from({length: 25}, (_, index) => index).map((ele, index) => {
                    return (
                        <div style={{...stylesPlanerView.times, top: (index + 1) * lineHeight}} key={"time_" + index}>
                            <div style={stylesPlanerView.label}>{index}</div>
                            <div style={stylesPlanerView.line}/>
                            <div style={stylesPlanerView.label}>{index}</div>
                        </div>);
                })}
            </div>}
            <div style={stylesPlanerView.daysContainer}>
                {weekdays?.map((day, index) =>
                    <div
                        style={{...(isSchedulePlaner ?
                            isInPast(startOfWeek, index) ?
                                stylesPlanerView.dayPast :
                                stylesPlanerView.day :
                            stylesPlanerView.day),
                            ...previewStyle
                        }}
                        key={(isSchedulePlaner?"s":"p")+"_day_" + index}
                        id={(isSchedulePlaner?"s":"p")+"_day_" + index}
                        onMouseEnter={() => setHoveredDay(index)}
                        onDragOver={() => setHoveredDay(index)}
                        className={"calender-day"}
                    >
                        {!preview && <div className={"day-label"}>{day.name}</div>}
                        {(isSchedulePlaner || addModal !== index) && renderItems(index)}
                        {isSchedulePlaner ? addModal === index && <AddCourse
                            initBegin={calcPxToTime(getTop())}
                            initEnd={calcPxToTime(getTop() + hoverItemHeight)}
                            style={{marginTop: addCoursePos}}
                            onAbort={() => setAddModal(-1)}
                            onSave={addToWeek}
                            editValues={editValues}
                            weekday={index}
                            startOfWeek={startOfWeek}
                            checkbox={checkbox}
                            courseTypes={courseTypes}
                            locations={locations}
                            coaches={coaches}
                        /> :
                            addModal === index &&
                            <Component onSave={addToWeek} tags={tags} setTags={setTags} onClose={() => setAddModal(-1)} editValues={editValues}/>
                        }
                        {startOfWeek && isToday(startOfWeek, index) && <div style={{
                            height: preview? 2: 5,
                            background: "red",
                            left: getLeft(index) + 'px',
                            top: (startToInt(String(new Date().getHours()).padStart(2,"0")+":"+String(new Date().getMinutes()).padStart(2,"0")) + 1) * (preview? previewHeight/25: lineHeight) + 'px',
                            width: getWidthOfDay(index),
                            position: "absolute",
                            zIndex: 10
                        }}/>}
                    </div>
                )}
            </div>
            {isSchedulePlaner && hoveredDay > -1 /*&& !draggedItem*/ && !resizeItem && <div style={{
                ...stylesPlanerView.hoverItem,
                left: hoveredLeft + 'px',
                top: hoverTop + 'px',
                height: hoverItemHeight + "px",
                width: hoveredWidth + 'px',
                background: stylesPlanerView.hoverItem.background,
                padding:5,
                fontSize: "0.8rem",
                overflow: "hidden",
                color: "var(--darkgray)"
            }}>{isInPast(startOfWeek, weekdays?.length === 1? 6: hoveredDay)?"Vergangenheit kann nicht bearbeitet werden.": ""}</div>}
        </div>
        {deleteModal && <Modal header={"Kurs löschen"}
                               actionP={()=>onDelete(0)}
                               actionS={()=>onDelete(1)}
                               buttonP={"Löschen"} buttonS={"Abbrechen"}
                               valid={true}
                               children={"Willst du " + (checkbox?"die ganze Serie": "den Kurs") + " wirklich löschen?"}/>}
    </div>);
}